export abstract class ClientPasswordRecoveryTokenModel {
    public static TYPE_NEW_PASSWORD_VERIFICATION_CODE = 1;
    public static TYPE_TEMPORARY_CODE = 2;
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/models/client-password-recovery-token.model.ts